<template>
  <v-card>
    <v-card-title>
      <v-text-field v-model="search" append-icon="search"
        label="Cauta client dupa nume, telefon, strada, adresa, nr fabricatie, contract" placeholder="Cautare..."
        single-line>
      </v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="listClients" class="elevation-1">
      <template v-slot:[`item.name`]="{ item }">
        <span :class="{
          'red--text': item.isSpecial,
          'font-weight-bold': item.isSpecial,
        }">
          {{ item.name }}
        </span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <router-link :to="{ name: 'Note', params: { clientId: item.id } }">
              <v-icon class="mr-2" v-bind="attrs" v-on="on"> note_add </v-icon>
            </router-link>
          </template>
          <span>Vezi note</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <router-link :to="{ name: 'Documente', params: { clientId: item.id } }">
              <v-icon class="mr-2" v-bind="attrs" v-on="on">
                description
              </v-icon>
            </router-link>
          </template>
          <span>Vezi documente</span>
        </v-tooltip>
        <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon v-if="show" @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
      <router-link to="/clients/create">
        <v-btn color="red" fab small dark fixed bottom justify-center>
          <v-icon>add</v-icon>
        </v-btn>
      </router-link>
    </v-layout>
  </v-card>
</template>

<script>
import { hasAccess, PERMISSION_LEVEL_ADMIN } from '../../utils/permissions';

export default {
  name: 'list-clients',
  data() {
    return {
      search: '',
      show: hasAccess(PERMISSION_LEVEL_ADMIN),
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Nume',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Adresa',
          align: 'center',
          value: 'addressDetails',
          sortable: true,
        },
        {
          text: 'Actiuni',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    const searchParam = this.$route.query.search;
    if (searchParam) {
      this.search = searchParam;
    } else {
      this.$store.dispatch('clients/getClients');
    }
  },
  computed: {
    listClients() {
      return this.$store.state.clients.clients;
    },
  },
  methods: {
    editItem(item) {
      const { id } = item;
      this.$router.push({ name: 'Editare client', params: { id } });
    },
    gotoNotes(item) {
      this.$router.push({ path: `/clients/${item.id}/notes` });
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('clients/delete', item.id);
      }
    },
  },

  watch: {
    search(query) {
      this.$store.dispatch('clients/search', query);
      this.$router.push({
        name: 'Clienti',
        query: {
          search: query,
        },
      });
    },
  },
};
</script>
